import React, { Component } from "react";
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { ResponsiveTable } from '../../../common/components/data-display';
import { currencyFormatter, formatDateTime } from '../../../common/utils/helpers';
import Table from 'antd/lib/table';
import { selectAccount } from "../../auth/ducks";
import { accountRoles } from "../../../common/enums";
const { Column } = Table;

let PenaltyFeeSummary = props => {
    const { items } = props
    return (
        <div>
            <table>
            <tbody>
                <tr>
                    <td style={{ width: "60%" }}>Spolu: </td>
                    <td style={{ width: "15%", paddingLeft: '10px'  }}>{currencyFormatter(items.filter(item => item.storno !== true).reduce((total, item) => total + Number(item.amount), 0))}  </td>
                    <td style={{ width: "25%", paddingLeft: '10px'  }}>{currencyFormatter(items.filter(item => item.storno !== true).reduce((total, item) => total + Number(item.unpaidAmount), 0))}</td>
                </tr>
            </tbody>
            </table>   
        </div> 
    )
}
    
    

const mapStateToProps = state => ({
    account: selectAccount(state),
  });
@translate()
@connect(mapStateToProps, undefined)
export default class PenaltyFeeList extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        items: PropTypes.array,
        pagination: PropTypes.object,
        onDelete: PropTypes.func,
        isLoading: PropTypes.bool,
        account: PropTypes.object,
    };


    

    render() {
        const {
            t,
            items,
            pagination,
            onTableChange,
            onDelete,
            isLoading,
            account
        } = this.props;

        let footerComponent = (
            <div>
                <PenaltyFeeSummary items={items} />
            </div>
        )

        return (
            <ResponsiveTable
                dataSource={items}
                rowKey={item => item.id}
                pagination={pagination}
                loading={isLoading}
                footer={() => { return footerComponent }}
            >
                <Column
                    title={t('Dátum a čas vyrúbenia')}
                    dataIndex="createdAt"
                    key="createdAt"
                    width='20%'
                    render={createdAt => formatDateTime(createdAt)}
                />
                <Column
                    title={t('Typ poplatku')}
                    dataIndex="type"
                    key="type"
                    width='20%'
                    render={type => t(type)}
                />
                <Column
                    title={t('Číslo splátky')}
                    dataIndex="installment"
                    key="installment"
                    width='20%'
                    render={installment => installment.month}
                />
                <Column
                    title={t('Suma poplatku')}
                    dataIndex="amount"
                    key="amount"
                    width='15%'
                    render={amount => currencyFormatter(amount)}
                />
                <Column
                    title={t('Neuhradená suma')}
                    dataIndex="unpaidAmount"
                    key="unpaidAmount"
                    width='15%'
                    render={unpaidAmount => currencyFormatter(unpaidAmount)}
                />
                <Column
                    title={t('Storno')}
                    key="action"
                    width='10%'
                    render={(item) => {
                        if (item.storno) {
                            return (<div>
                                <span>stornované dňa: {formatDateTime(item.dateOfStorno)}</span><br />
                                <span>stornoval: {item.stornoOperator.nameFirst} {item.stornoOperator.nameLast}</span>
                            </div>);
                        } else if (item.unpaidAmount === item.amount || ( account.role === accountRoles.ADMINISTRATOR )) {
                            return (<span>
                                <Link onClick={() => this.props.onDelete(item)}>{t('Storno')}</Link>
                            </span>);
                        } else {
                            return <span></span>
                        }
                    }}
                />
            </ResponsiveTable>
        );
    }
}


// WEBPACK FOOTER //
// ./src/features/penalty-fee/components/PenaltyFeeList.js